<template>
    <div>
        <ul class="list">
            <li v-for="(item,  index) in list" v-bind:key="index">
                <div class="head">
                    <span>订单编号：AYJG20180119000019756666J </span>
                    <span class="right">待预约...</span>
                </div>
                <div class="left">
                    <img :src="imageURL" alt="">
                </div>
                <div class="right">
                    <span>夕阳红老年套餐A</span>
                    <div class="gray"><span>梁朝伟</span><span class="num">1391723712</span></div>
                </div>
                <div class="items">
                    <ul>
                        <li>
                            <span>【基础项目】</span><span class="num">x10</span>
                        </li>
                        <li>
                            <span>【新增项目】</span><span class="num">x3</span>
                        </li>
                    </ul>
                </div>
                <div class="total">
                    <span>小计：</span><b>¥{{item.price}}</b>
                </div>
                <div class="btns">
                    <!-- <button @click="tuikuan" class="tuikuan">发起退款</button> -->
                    <button @click="goYuYue" class="yuyue blue">预约</button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { Dialog,Toast  } from 'vant';
    export default {
        data() {
            return {
                imageURL: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1528431608002&di=00ad850a978b02b196e003a24b19c6c2&imgtype=0&src=http%3A%2F%2Fimg.mp.itc.cn%2Fupload%2F20170413%2F168a43e2babc420d9fe640a2286cb7c6_th.jpeg',
                list: [{
                    checked: false,
                    price: 2113
                }, {
                    checked: false,
                    price: 1891
                }],
                allchecked: false,
                num: 0,
                totalPrice: 0
            }
        },
        methods: {
            change() {
                this.list.forEach(n => {
                    n.checked = this.allchecked;
                })
            },
            tuikuan(){
                Dialog.confirm({
                    title: '退款',
                    message: '确定退款吗？'
                    }).then(() => {
                        Toast.loading({
                            mask: true,
                            message: '处理中...'
                        });
                        setTimeout(() => {
                            Toast.success('退款成功！');
                        }, 3000);
                    }).catch(() => {
                    // on cancel
                });
            },
            submit() {
                //提交订单数据
                this.$router.push('/user/confimOrder')
            },
            goYuYue(){
                this.$router.push('/user/singleYuYue')
            },
            itemchange() {
                this.num = 0;
                this.totalPrice = 0;
                this.list.forEach(n => {
                    if (!n.checked) {
                        this.allchecked = false;
                    } else {
                        this.num++;
                        this.totalPrice += n.price;
                    }
                })
            }
        },
    }
</script>

<style scoped lang='less'>
    .van-checkbox {
        display: inline;
    }
    .buy {
        .btnbuy {
            padding: 0 1em;
        }
        .price {
            span {
                display: inline;
                font-size: 0.8rem !important;
                margin-left: 8em;
            }
        }
    }
    .gray {
        color: #BCBCBC;
    }
    .num {
        position: absolute;
        right: 1em;
    }
    .list {
        .head {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            box-sizing: border-box;
            border-width: 4px;
            border-style: solid;
            border-color: #43852E;
            border-top: 0px;
            border-right: 0px;
            border-bottom: 0px;
            padding-left: 1em;
            font-size: 0.8rem;
            height: 2.5em;
            line-height: 2.5em;
            border-bottom: 1px solid #eee;
            .right{
                position: absolute;
                right: 2em;
                top: 0;
                margin-top: 0;
                font-size: 0.8rem;
                color:#FF7C3E; 
            }
        }
        .btns {
            position: absolute;
            bottom: 0;
            clear: both;
            text-align: right;
            font-size: 0.8rem;
            padding-top: 0.5em;
            width: 100%;
            left: 0;
            border-top: 1px solid #eee;
            button {
                border-radius: 15px;
                border: 1px solid #ccc;
                color: #666;
                width: 6em;
                text-align: center;
                line-height: 1.8em;
                margin-bottom: 0.4em;
                background: #fff;
            }
            .blue {
                color: #99C51D;
                border-color: #99C51D;
            }
        }
        .right {
            margin-top: 0.5em;
            font-size: 1rem;
            >span {
                display: block;
                line-height: 2em;
            }
        }
        .total {
            text-align: right;
            font-size: 0.8rem;
            margin-top: 0.5em;
            b {
                font-size: 1rem;
                color: #FF7C3E;
            }
        }
        .items {
            margin-top: 0.8em;
            li {
                position: relative;
                font-size: 0.8rem;
            }
        }
        >li {
            height: 11em;
            position: relative;
            padding: 2em 1em 0.2em 9em;
            border-bottom: 1px solid #eee;
            overflow: hidden;
        }
        .left {
            position: absolute;
            left: 1em;
            top: 1em;
            .van-checkbox {
                position: absolute;
                top: 2.5em;
                left: 0;
            }
            img {
                width: 5em;
                height: 4em;
                position: absolute;
                left: 2em;
                top: 2em;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/orderTuan.vue